<template>
  <div
    class="modal fade"
    id="cgv-modal"
    aria-hidden="true"
    aria-labelledby="exampleGrid"
    role="dialog"
  >
    <div class="modal-dialog modal-simple modal-center">
      <div class="modal-content">
        <form autocomplete="off">
          <div class="modal-header">
            <div class="container">
              <div class="row header">
                <div class="col-8">
                  <h4 class="modal-title">Conditions générales de vente</h4>
                </div>
                <div class="col-4">
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    @click.prevent="closeCgvModal()"
                  >
                    <span aria-hidden="true" class="close-btn">&times;</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-body">
            <div class="row">
              <p
                class="rental-description"
                v-html=content
                v-if=content
              ></p>
            </div>
          </div>

          <v-loading
            :isLoading="smallLoading"
            :height="50"
            :width="50"
            :viewbox="'0 0 50 50'"
            :cx="25"
            :cy="25"
            :r="22"
            :isHeightAuto="true"
          ></v-loading>
          <div class="modal-footer text-center">
            <button
              type="button"
              class="btn waves-effect waves-classic btn-cancel"
              @click.prevent="closeCgvModal()"
              data-dismiss="modal"
              :disabled="smallLoading"
            >
              Ok
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from "../../mixins/mixin";
import Switches from "vue-switches";

export default {
  name: "CgvModal",

  props: ["content"],

  data() {
    return {
      smallLoading: false,
    };
  },

  components: {
    VLoading: require("components/loading/loading.vue"),
    Switches,
  },

  mixins: [mixin],

  mounted() {},

  computed: {},

  methods: {
    closeCgvModal() {
      this.closeModal("#cgv-modal");
    },
  },
};
</script>



// WEBPACK FOOTER //
// CgvModal.vue?d3fd4232